import { FC } from 'react';

import styled from 'styled-components';
/*
import { WorldLogo as WorldLogoIcon } from '@assets/icons';
import { Row } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='3' ry='3' stroke='%23682A7A8C' stroke-width='3' stroke-dasharray='.5%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  padding: 5px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 5px 10px 5px 10px;
  }
`;

const WrapperContent = styled.div``;
*/
export const WorldLogoLabel = styled.span`
  display: block;
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.purple};

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    font-size: 14px;
  }
`;
export const WorldLogoText = styled.span`
  color: ${({ theme }) => theme.palette.purple};
  display: block;
  margin-top: -5px;
  font-size: 12px;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    font-size: 14px;
  }
`;

interface WorldLogoProps {
  label?: string;
}

const WorldLogo: FC<WorldLogoProps> = () => {
  return <></>;
  /*
  // Shop&Fly da kullanılmıyor.
  return (
    <Wrapper>
      <WrapperContent>
        <Row alignItems={'center'}>
          <CustomIcon icon={WorldLogoIcon} width={75} height={12} />
          <WorldLogoLabel>‘e özel</WorldLogoLabel>
        </Row>
        <WorldLogoText>{label} taksit fırsatı!</WorldLogoText>
      </WrapperContent>
    </Wrapper>
  );
  */
};

export default WorldLogo;
